import { render, staticRenderFns } from "./SidebarOption.vue?vue&type=template&id=d8ba77a6&scoped=true&"
import script from "./SidebarOption.vue?vue&type=script&lang=js&"
export * from "./SidebarOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8ba77a6",
  null
  
)

export default component.exports